import QuickOptionButton from "./QuickOptionButton";
import { Clipboard } from "react-feather";
import { useState } from "react";
import ModalContainer from "../../../Staff/containers/ModalContainer";
import FormStaf from "../../../Staff/components/FormStaff";

const UpdateProfil = ({dataStaf}) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <>
      <QuickOptionButton
        title="Update Profil"
        icon={<Clipboard />}
        onClick={toggle}
      />
      <ModalContainer title="Update Profil" isOpen={isOpen} toggle={toggle}>
        <FormStaf
          data={dataStaf}
          toggle={toggle}
          isOpen={isOpen}
        />
      </ModalContainer>
    </>
  );
};

export default UpdateProfil;
